import { useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setToken } from "@/redux/authSlice";
import { setAppParams } from "@/redux/appSlice"; // Import the action

const useAuthFromUrl = () => {
  const [searchParams] = useSearchParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    const token = searchParams.get("token");
    const appVariant = searchParams.get("app_variant");
    const source = searchParams.get("source");

    if (token) {
      try {
        // Set in localStorage
        localStorage.setItem("auth_token", token);
        if (appVariant) {
          localStorage.setItem("app_variant", appVariant);
        }

        if (source) {
          localStorage.setItem("source", source);
        }

        // Dispatch token to Redux
        dispatch(setToken({ auth_token: token }));

        // Dispatch app_variant and source to Redux
        dispatch(setAppParams({ app_variant: appVariant, source }));

        // Redirect to home
        navigate("/signin");
      } catch (error) {
        console.error("Failed to process token or parameters from URL:", error);
        // Handle error, like showing an error message or redirecting to login
      }
    }
  }, [searchParams, dispatch, navigate]);
};

export default useAuthFromUrl;
